
import { StoresLoadedObservable$, FrameworkServiceLoader } from '@/services/framework.service';
import { StateService } from '@/services/state.service';
import { RulesService } from '@/services/rules.service';
import { NotificationService } from '@/services/notification.service';

let frameworkLoadedSubscription;

export const baseComponentMixin = {
	data() {
		return {
			isWaiting: true,
			isLoadingOk: false,
			isServerError: false,
			userKnown: false,
			userAuthenticated: false
		};
	},
	mounted() {
		StateService.initializeMixin(this.$el);
	},
	destroyed() {
		if (frameworkLoadedSubscription) frameworkLoadedSubscription.unsubscribe();
	},
	methods: {
		getFrameworkData(methodDelegate, stores) {
			FrameworkServiceLoader.initialize(stores);
			frameworkLoadedSubscription = StoresLoadedObservable$.subscribe(dataIsReady => {
				if (dataIsReady) {
					RulesService.initialize().then(() => {
						this.userKnown = StateService.isRemembered();
						this.userAuthenticated = StateService.isAuthenticated();
						methodDelegate();
					});
				}
			});
		},
		mountServerError(killUi, message, deferred) {
			NotificationService.close(); // Clear any existing notification (prevents ID collision)
			if (deferred) {
				NotificationService.danger(message || 'Sorry, an unexpected error occurred. Please try again.').deferred().trigger();
			} else {
				NotificationService.danger(message || 'Sorry, an unexpected error occurred. Please try again.').trigger();
			}
			this.isWaiting = false;
			this.isServerError = killUi;
		}
	}
};
